var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21911 12.0009L3.18808 18.094L18.1624 11.0009L3.18808 3.90783L5.21911 10.0009H10.4983C11.0506 10.0009 11.4983 10.4486 11.4983 11.0009C11.4983 11.5532 11.0506 12.0009 10.4983 12.0009H5.21911ZM3.44425 11.0009L0.549664 2.31715C0.271167 1.48166 1.13053 0.720172 1.92643 1.09718L20.9264 10.0972C21.689 10.4584 21.689 11.5434 20.9264 11.9047L1.92643 20.9047C1.13053 21.2817 0.271167 20.5202 0.549664 19.6847L3.44425 11.0009Z",
    fill: "#F1FAEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.ed7e7e042a3f129ed527407ef93f931c.svg";
export { ForwardRef as ReactComponent };